import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 24px;
  max-width: 500px;
  background: white;
  padding: 48px 32px;
  border-radius: 24px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
`;

export const IconWrapper = styled.div`
  width: 120px;
  height: 120px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.3);

  i {
    font-size: 60px;
    color: white;
  }
`;

export const Title = styled.h1`
  font-size: 2rem;
  font-weight: 400;
  color: #1f2937;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-family: 'Anton', sans-serif;
`;

export const Message = styled.p`
  font-size: 1.1rem;
  color: #6b7280;
  line-height: 1.6;
  margin: 0;
  font-family: 'Inter', sans-serif;
`;
